import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from 'src/styles/media';

import imgArrowIcon from 'src/assets/images/icons/next.svg';

class Slider extends Component {
  state = {
    activeSlide: 0,
  };

  static propTypes = {
    slides: PropTypes.array,
  };

  static defaultProps = {
    slides: [],
  };

  handleNext = () => {
    if (this.state.activeSlide === this.props.slides.length - 1) {
      this.setState({ activeSlide: 0 });
    } else {
      this.setState({ activeSlide: this.state.activeSlide + 1 });
    }
  };

  handlePrev = () => {
    if (this.state.activeSlide === 0) {
      this.setState({ activeSlide: this.props.slides.length - 1 });
    } else {
      this.setState({ activeSlide: this.state.activeSlide - 1 });
    }
  };

  render() {
    const { slides } = this.props;
    const { activeSlide } = this.state;

    return (
      <Root>
        <Container
          style={{
            width: `${slides.length * 100}%`,
            transform: `translateX(-${(activeSlide / slides.length) * 100}%)`,
          }}
        >
          {slides.map((slide, index) => (
            <Slide
              style={{
                width: `${(1 / slides.length) * 100}%`,
                backgroundImage: `url(${slide.image})`,
              }}
              key={index}
            />
          ))}
        </Container>
        <Caption>
          {slides[activeSlide].caption}
          &nbsp;
          <Actions>
            <PrevArrow src={imgArrowIcon} onClick={this.handlePrev} />
            <Count>
              {activeSlide + 1 < 10 ? '0' : ''}
              {activeSlide + 1} | {slides.length < 10 ? '0' : ''}
              {slides.length}
            </Count>
            <NextArrow src={imgArrowIcon} onClick={this.handleNext} />
          </Actions>
        </Caption>
      </Root>
    );
  }
}

const Root = styled.div`
  overflow: hidden;
  position: relative;
  height: 100%;
  @media (max-width: ${media.md}) {
    height: 75vw;
  }
  @media (max-width: ${media.sm}) {
    height: 365px;
  }
`;

const Container = styled.div`
  height: 100%;
  display: flex;
  transition: all 0.5s;
`;

const Slide = styled.div`
  position: relative;
  background-size: cover;
  background-position: 50% 50%;
  &::before {
    content: '';
    display: block;
  }
`;

const Caption = styled.div`
  width: 80%;
  max-width: 620px;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 22px;
  color: #fff;
  background: ${({ theme }) => theme.colorBackground};
  font-size: 11px;
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.font};
  @media (max-width: ${media.md}) {
    width: 100%;
    max-width: 100%;
  }
`;

const Count = styled.div`
  width: 50px;
  text-align: center;
  padding-top: 2px;
`;

const Actions = styled.div`
  height: 100%;
  position: absolute;
  right: 18px;
  display: flex;
  align-items: center;
  top: 0%;
  @media (max-width: ${media.md}) {
    top: -100%;
    right: 50%;
    transform: translateX(50%);
  }
`;

const NextArrow = styled.img`
  cursor: pointer;
`;

const PrevArrow = styled.img`
  cursor: pointer;
  transform: scaleX(-1);
`;

export default Slider;



// WEBPACK FOOTER //
// ./src/components/Slider.js